import { Tabs } from '@mantine/core'
import { useQueryClient } from '@tanstack/react-query'
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useOrpc } from '@/hooks/useClient'
import { CaseDrawer } from './components/CaseDrawer'

/**
 * The /billing shell: the Claims / Accounting reports tabs, the active tab's page,
 * and the case drawer both tabs open through `?drawer={encounterId}`.
 */
export function BillingLayout() {
  const orpc = useOrpc()
  const queryClient = useQueryClient()
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const tab = location.pathname.startsWith('/billing/accounting')
    ? '/billing/accounting'
    : '/billing'

  // Drawer edits can change the report's figures and filter options, so they refetch on close.
  const closeDrawer = () => {
    setSearchParams(
      (params) => {
        params.delete('drawer')
        return params
      },
      { replace: true },
    )

    void queryClient.invalidateQueries({ queryKey: orpc.billingV2Report.key() })
    void queryClient.invalidateQueries({ queryKey: orpc.billingV2ReportFilterOptions.key() })
  }

  return (
    <>
      <Tabs value={tab} onChange={(value) => value && value !== tab && navigate(value)}>
        <Tabs.List>
          <Tabs.Tab value="/billing">Claims</Tabs.Tab>
          <Tabs.Tab value="/billing/accounting">Accounting reports</Tabs.Tab>
        </Tabs.List>
      </Tabs>

      <Outlet />

      <CaseDrawer encounterId={searchParams.get('drawer')} onClose={closeDrawer} />
    </>
  )
}
